import { autoAssignLeadV2 } from "@/modules/lead-page/api/lead-page.v2.api";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { queryClient } from "@/queryClient";
import { useContext } from "react";
import { useMutation } from '@tanstack/react-query';

const useAutoAssign = () => {
  const { lead } = useContext(LeadPageContext);
  const journeyUId = lead?.data?.lead?.journey_uid;

  const {
    mutate: autoAssignLeadMutation,
    isLoading: isLoadingAutoAssign,
    isError,
    isSuccess,
  } = useMutation({
    mutationFn: autoAssignLeadV2,
    onSuccess: () => {
      // TODO: we need to invalidate getLead and getStagesByJourney for specific lead
      queryClient.invalidateQueries({ queryKey: ["getLead"] });
      queryClient.invalidateQueries({ queryKey: ["getComments"] });
      queryClient.invalidateQueries({ queryKey: ["getStagesByJourney"] });
    },
  });

  const handleAutoAssign = () => {
    if (journeyUId) {
      autoAssignLeadMutation(journeyUId);
    }
  };
  return {
    isLoadingAutoAssign,
    handleAutoAssign,
    isError,
    isSuccess,
  };
};

export default useAutoAssign;
